export function mixin(Hop) {
    function returnFalse() {
        return false;
    }

    function returnNull() {
        return null;
    }

    function isQuotaExceeded(e) {
        let quotaExceeded = false;
        if (e) {
            if (e.code) {
                switch (e.code) {
                    case 22:
                        quotaExceeded = true;
                        break;
                    case 1014:
                        // Firefox
                        if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            quotaExceeded = true;
                        }
                        break;
                }
            } else if (e.number === -2147024882) {
                // Internet Explorer 8
                quotaExceeded = true;
            }
        }
        return quotaExceeded;
    }

    function noOp() {}

    function NullStorage() {
        'use strict';
        this.clear = noOp;
        this.key = returnNull;
        this.length = 0;
        this.getItem = returnNull;
        this.removeItem = noOp;
        this.setItem = returnFalse;
    }

    /**
     * Wraps a Storage to prevent errors when using browsers in private mode.
     *
     * @param {Object} storageProvider The provider.
     * @constructor
     */
    function StorageWrapper(storageProvider) {
        'use strict';

        let s;
        try {
            s = storageProvider();
            if (!s) {
                // for instance, Safari 8 for iPhone will return null
                s = new NullStorage();
            }
        } catch (e) {
            if (
                e.name === 'SecurityError' ||
                e.toString().indexOf('SecurityError') !== -1 ||
                e.toString().indexOf('Access is denied.') !== -1 ||
                e.toString().indexOf('Accès refusé.') !== -1 ||
                e.toString().indexOf('Access is denied for this document') !== -1
            ) {
                s = new NullStorage();
            } else {
                throw e;
            }
        }

        this.clear = s.clear.bind(s);
        this.key = s.key.bind(s);
        this.length = function () {
            return s.length;
        };
        this.getItem = s.getItem.bind(s);
        this.removeItem = s.removeItem.bind(s);

        /**
         * Wraps setItem to catch QuotaExceededError when using Safari in private mode.
         * Other errors are xca
         *
         * @param {string} key The key.
         * @param {*} value The value.
         * @return {boolean} whether item has been set
         */
        this.setItem = function (key, value) {
            try {
                const result = s.setItem(key, value);
                // NullStorage case
                if (typeof result !== 'undefined') {
                    return result;
                }
                return true;
            } catch (e) {
                // Safari's private mode disables sessionStorage and will throw QuotaExceededError
                // other errors should be rethrown
                if (!isQuotaExceeded(e)) {
                    throw e;
                }
                return false;
            }
        };
    }

    Hop.localStorage = new StorageWrapper(() => {
        return window.localStorage;
    });

    Hop.sessionStorage = new StorageWrapper(() => {
        return window.sessionStorage;
    });

    Hop.setCookie = function (cname, cvalue, options) {
        options = options || {};

        const cookieBuilder = [cname, '=', cvalue];

        if (options.expires) {
            cookieBuilder.push('; expires=', options.expires);
        } else if (options.expiresInDays !== undefined) {
            const d = new Date();
            d.setTime(d.getTime() + options.expiresInDays * 24 * 60 * 60 * 1000);
            cookieBuilder.push('; expires=', d.toUTCString());
        }

        if (options.path) {
            cookieBuilder.push('; path=', options.path);
        }

        document.cookie = cookieBuilder.join('');
    };

    Hop.getCookie = function (cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };
}
